// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__RIUOi","large":"styles_large__1RRMd"};